import React, { useCallback, useRef, useState } from 'react';
import useStyles from './ForgotPassword.styles';
import { Button, Card, FormControl, Grid, Hidden, Input, Link, Typography } from "@mui/material";
import { EnhancedEncryptionOutlined } from "@mui/icons-material";
import { Link as RouterLink } from 'react-router-dom';
import api from 'api';
import useRequest from 'hooks/useRequest';



const ForgotPassword = () => {
	const classes             = useStyles(),
		  formRef             = useRef(null),
		  [ email, setEmail ] = useState('');

	const sendEmailResetRequest = useCallback(() => {
		return api.post('/auth/reset-password', { email });
	}, [ email ]);

	const {
			  loading,
			  hasLoaded,
			  error,
			  refetch: requestPasswordReset,
		  } = useRequest({ requestFunction: sendEmailResetRequest, lazy: true });


	const handleChangeEmail = e => {
		setEmail(e.target.value);
	};


	const handleSubmit = async (e) => {
		e.preventDefault();
		await requestPasswordReset();
	};

	return (
		<div className={classes.root}>
			<div className={classes.child}>
				<Grid container spacing={0} className={classes.fullHeightWidth}>
					<Hidden mdDown>
						<Grid item md={5} className={classes.leftCardWrapper}>
							<Card className={classes.leftCard} raised>
								<div className={classes.leftCardInner}>
									<div>
										<EnhancedEncryptionOutlined className={classes.leftCardIcon} />
									</div>
									<div>
										<Typography variant="h4" className={classes.marginBottom}>Forgot
											Password</Typography>
									</div>
									<div>
										<Typography>
											Hey, it happens to the best of us. Enter your email address in the form
											to the right and we'll send you an email to reset your password so you can
											get back up and running. If you want to get back to the homepage, click
											<Link
												component={RouterLink}
												to="/"
												color="inherit"
											> here</Link>.
										</Typography>
									</div>

								</div>
							</Card>
						</Grid>
					</Hidden>


					<Grid item xs={12} md={7} className={classes.rightCardWrapper}>
						<Card className={classes.rightCard} raised>
							{!hasLoaded && <>
								<Hidden mdUp>
									<div>
										<Typography>
											Hey, it happens to the best of us. Enter your email address in the form and
											we'll send you a link to reset your password so you can get back up and
											running. If you want to get back to the homepage, click
											<Link
												component={RouterLink}
												to="/"
												color="inherit"
											> here</Link>.
										</Typography>
									</div>
								</Hidden>
								<form onSubmit={handleSubmit} ref={formRef}>

									{Boolean(error) &&
										<Typography>
											Oops, it looks like there was an error sending your request. Please make
											sure you've entered a valid email address and try again. If you've recently
											submitted a password reset request, please wait a few minutes before
											submitting another.
										</Typography>
									}

									<FormControl fullWidth margin="normal">
										<Input
											type="text"
											placeholder="Email Address"
											onChange={handleChangeEmail}
											value={email}
											className={classes.inputs}
											disabled={loading}
										/>
									</FormControl>

									<FormControl fullWidth margin="normal">

										<Button
											variant="contained"
											color="primary"
											className={classes.inputs}
											type="submit"
											disabled={loading}
										>
											Submit
										</Button>
									</FormControl>
								</form>
							</>}

							{hasLoaded &&
								<>
									<Typography className={classes.marginBottom}>
										We've received your request. If the email address you entered is tied to a
										valid account, you'll receive an email with instructions to reset your password
										shortly. The link contained in the email is only valid for 1 hour.
									</Typography>

									<Typography>
										Click <Link
										component={RouterLink}
										to="/"
										color="inherit"
									>
										here
									</Link> to return to the homepage.
									</Typography>
								</>
							}

						</Card>
					</Grid>
				</Grid>
			</div>
		</div>
	);

};


export default ForgotPassword;
